import { axiosInstance } from '../../../api';
const BASE_PATH = '/hiring_pipeline';

//Get welcome email templates data API Call
export let getWelcomeEmailTemplateConfigs = async (pipeline_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_welcome_email_template_configs', {
            pipeline_id: pipeline_id
        })
        return value;
    } catch (error) {
        return error
    }
}

//submit email templates data API Call
export let submitEmailTemplate = async (pipeline_id, email_subject, email_body, is_welcome_email_enable) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/submit_welcome_email_template', {
            pipeline_id: pipeline_id,
            email_subject: email_subject,
            email_body: email_body,
            is_welcome_email_enable: is_welcome_email_enable
        })
        return value;
    } catch (error) {
        return error
    }
}

//Get reject email templates data API Call
export let getRejectEmailTemplateConfigs = async (pipeline_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_reject_email_template_configs', {
            pipeline_id: pipeline_id
        })
        return value;
    } catch (error) {
        return error
    }
}

//submit reject email templates data API Call
export let submitRejectEmailTemplate = async (pipeline_id, email_subject, email_body, is_reject_email_enable) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/submit_reject_email_template', {
            pipeline_id: pipeline_id,
            email_subject: email_subject,
            email_body: email_body,
            is_reject_email_enable: is_reject_email_enable
        })
        return value;
    } catch (error) {
        return error
    }
}

//send reqest email for the refrees
export let requestRefereeDetailsFromCandidate = async ( reference_checks_session_id, receiver , to_email,company_name, position, contact_email) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/request_referee_details_from_candidate', {
            reference_checks_session_id: reference_checks_session_id,
            receiver: receiver,
            to_email: to_email,
            company_name: company_name,
            position: position,
            contact_email: contact_email,
        })
        return value;
    } catch (error) {
        return error
    }
}